module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/availability-icon-277d3232af34aa1dfcef1693d2758fa5.png";